export { default } from "./getContentUrl.js";
